<template>
  <div>
    <nav id="nav_id" class="nav">
      <div class="inner">
        <div class="nav_top">
          <div class="inner">
            <h1 class="h1">
              <span>협회 소개</span>
            </h1>
          </div>
        </div>
        <div class="nav_btm">
          <div class="inner">
            <div class="line dep01">
              <div class="inner">
                <ul>
                  <li>
                    <router-link tag="button" to="/about/greeting"
                      ><span>인사말</span></router-link
                    >
                  </li>
                  <li>
                    <router-link tag="button" to="/about/history"
                      ><span>협회 연혁</span></router-link
                    >
                  </li>
<!--                  <li>-->
<!--                    <router-link tag="button" to="/about/exctv"-->
<!--                      ><span>임원 소개</span></router-link-->
<!--                    >-->
<!--                  </li>-->
                  <li>
                    <router-link tag="button" to="/about/orgnz-chart"
                      ><span>조직도</span></router-link
                    >
                  </li>
                  <li>
                    <router-link tag="button" to="/about/road"
                      ><span>찾아오는 길</span></router-link
                    >
                  </li>
                  <li>
                    <router-link tag="button" to="/about/ci"
                      ><span>CI</span></router-link
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'about-index'
}
</script>

<style scoped></style>
